//
// Copyright (c) 2011-2026 by Curalate, Inc.
//

import React from 'react';
import styled from 'styled-components';

import { ProductBasicFields } from '@campaigns/components/shared/product-details-modal/drawer/details/ProductBasicFields';
import { ProductDescriptionField } from '@campaigns/components/shared/product-details-modal/drawer/details/ProductDescriptionField';
import { ProductIdentifierFields } from '@campaigns/components/shared/product-details-modal/drawer/details/ProductIdentifierFields';
import { ProductImageSection } from '@campaigns/components/shared/product-details-modal/drawer/details/ProductImageSection';
import { ProductMetaFields } from '@campaigns/components/shared/product-details-modal/drawer/details/ProductMetaFields';
import { ProductSyndicationFields } from '@campaigns/components/shared/product-details-modal/drawer/details/ProductSyndicationFields';
import { VariationBasicFields } from '@campaigns/components/shared/product-details-modal/drawer/details/VariationBasicFields';
import { ShippingAvailabilityDateField } from '@campaigns/components/shared/product-details-modal/drawer/form/ShippingAvailabilityDateField';
import { HR } from '@components/atoms/hr/HR';
import { BodyBoldText } from '@components/atoms/text/Text';

interface ProductDetailsTabProps {
  isViewOnly: boolean;
}

export const ProductDetailsTab = ({ isViewOnly }: ProductDetailsTabProps) => {
  return (
    <Container>
      <SectionDivider>
        <SectionDividerText>Product Details</SectionDividerText>
        <HR />
      </SectionDivider>

      <ProductBasicFields isViewOnly={isViewOnly} />
      <ProductImageSection isViewOnly={isViewOnly} />
      <ProductMetaFields isViewOnly={isViewOnly} />
      <ProductDescriptionField isViewOnly={isViewOnly} />

      <SectionDivider>
        <SectionDividerText>Logistics Information</SectionDividerText>
        <HR />
      </SectionDivider>

      <VariationBasicFields isViewOnly={isViewOnly} />
      <ProductIdentifierFields isViewOnly={isViewOnly} />
      <ShippingAvailabilityDateField isViewOnly={isViewOnly} />
      <ProductSyndicationFields isViewOnly={isViewOnly} />
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacings[3]};
`;

const SectionDivider = styled.div`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacings[3]};

  ${HR} {
    flex: 1;
  }
`;

const SectionDividerText = styled(BodyBoldText)`
  white-space: nowrap;
`;
